import axiosClient from "./../apiClient.js";

const baseEndpoint = "/member";

export const memberObject = {
  userName: "",
  id: 0,
  titleId: 0,
  name: "",
  nameInMarathi: "",
  dateOfBirthId: "2024-12-14T12:41:14.130Z",
  dateOfBirth: "",
  bloodGroupId: 0,
  genderId: 0,
  qualificationId: 0,
  occupationId: 0,
  mobile: "",
  telephone: "",
  email: "",
  address_1: "",
  addressInMarathi_1: "",
  address_2: "",
  addressInMarathi_2: "",
  address_3: "",
  addressInMarathi_3: "",
  customArea: "",
  customAreaInMarathi: "",
  areaId: 0,
  area: "",
  talukaId: 0,
  districtId: 0,
  stateId: 0,
  pincode: "",
  pincodeInMarathi: "",
  nativeAddress_1: "",
  nativeAddressInMarathi_1: "",
  nativeAddress_2: "",
  nativeAddressInMarathi_2: "",
  nativeAddress_3: "",
  nativeAddressInMarathi_3: "",
  nativeCustomArea: "",
  nativeCustomAreaInMarathi: "",
  nativeAreaId: 0,
  nativeStateId: 0,
  nativeDistrictId: 0,
  nativeTalukaId: 0,
  nativePincode: "",
  nativePincodeInMarathi: "",
  oldMemberId: 0,
  applicationNumber: "",
  isMailSubscriped: false,
  isMessageSubscriped: false,
  statusId: 0,
  dateOfJoiningId: "2024-12-14T12:41:14.130Z",
  dateOfJoining: "",
};

export const searchMemberObject = {
  name: "",
  status: 0,
  gender: 0,
  bloodGroup: 0,
  area: 0,
  dateOfBirthFrom: "",
  dateOfBirthTo: "",
  dateOfJoiningFrom: "",
  dateOfJoiningTo: "",
  isMessageSubscriped: false,
  pageSize: 10,
  pageNumber: 1,
  isAgeFilterApplied: false,
};

export const get = (data) => {
  return axiosClient.post(`${baseEndpoint}/get`, JSON.stringify(data));
};

export const getById = (id) => {
  return axiosClient.get(`${baseEndpoint}/getbyid?id=${id}`);
};

export const nextRecord = (id) => {
  return axiosClient.get(`${baseEndpoint}/nextrecord`);
};

export const save = (data) => {
  return axiosClient.post(`${baseEndpoint}/save`, JSON.stringify(data));
};
